import { useEffect, useReducer, useContext } from 'react';

import api from '../../services/api';
import { AuthContext } from '../../context/Auth/AuthContext';

const reducer = (state, action) => {
  if (action.type === 'LOAD_WHATSAPPS') {
    const whatsApps = action.payload;
    return [...whatsApps];
  }

  if (action.type === 'UPDATE_WHATSAPPS') {
    const whatsApp = action.payload;
    const whatsAppIndex = state.findIndex((s) => s.id === whatsApp.id);

    if (whatsAppIndex !== -1) {
      state[whatsAppIndex] = whatsApp;
      return [...state];
    } else {
      return [whatsApp, ...state];
    }
  }

  if (action.type === 'UPDATE_SESSION') {
    const whatsApp = action.payload;
    const whatsAppIndex = state.findIndex((s) => s.id === whatsApp.id);

    if (whatsAppIndex !== -1) {
      state[whatsAppIndex].status = whatsApp.status;
      state[whatsAppIndex].updatedAt = whatsApp.updatedAt;
      state[whatsAppIndex].qrcode = whatsApp.qrcode;
      state[whatsAppIndex].retries = whatsApp.retries;
      return [...state];
    } else {
      return [...state];
    }
  }

  if (action.type === 'DELETE_WHATSAPPS') {
    const whatsAppId = action.payload;
    const whatsAppIndex = state.findIndex((s) => s.id === whatsAppId);
    if (whatsAppIndex !== -1) {
      state.splice(whatsAppIndex, 1);
    }
    return [...state];
  }

  if (action.type === 'RESET') {
    return [];
  }
};

const useWhatsApps = () => {
  const [whatsApps, dispatch] = useReducer(reducer, []);
  const { user, socket, isAuth } = useContext(AuthContext);

  // Só busca após autenticação confirmada
  useEffect(() => {
    if (!isAuth) return;

    const fetchSession = async () => {
      try {
        const { data } = await api.get('/whatsapp/?session=0');
        dispatch({ type: 'LOAD_WHATSAPPS', payload: data });
      } catch (err) {
        console.error(err.message);
      }
    };

    fetchSession();
  }, [isAuth]);

  useEffect(() => {
    if (!socket || typeof socket.on !== 'function') {
      console.warn('Socket não disponível em useWhatsApps');
      return;
    }

    if (user.companyId) {
      const companyId = user.companyId;

      const onCompanyWhatsapp = (data) => {
        if (data.action === 'update') {
          dispatch({ type: 'UPDATE_WHATSAPPS', payload: data.whatsapp });
        }
        if (data.action === 'delete') {
          dispatch({ type: 'DELETE_WHATSAPPS', payload: data.whatsappId });
        }
      };

      const onCompanyWhatsappSession = (data) => {
        if (data.action === 'update') {
          dispatch({ type: 'UPDATE_SESSION', payload: data.session });
        }
      };

      socket.on(`company-${companyId}-whatsapp`, onCompanyWhatsapp);
      socket.on(
        `company-${companyId}-whatsappSession`,
        onCompanyWhatsappSession,
      );

      return () => {
        if (socket && typeof socket.off === 'function') {
          socket.off(`company-${companyId}-whatsapp`, onCompanyWhatsapp);
          socket.off(
            `company-${companyId}-whatsappSession`,
            onCompanyWhatsappSession,
          );
        }
      };
    }
  }, [socket, user]);

  return { whatsApps };
};

export default useWhatsApps;
